import { ITabList } from '@components/common/navigator-tab';

export * from './site-summary-page';

export * from './kaess-site-summary-page';
export * from './site-specialist-site-summery-page';

export const SiteSummaryTab: ITabList[] = [
	{
		key: 1,
		name: 'All Sites',
		pathUrl: '/site-summary',
		tabIcon: 'icon-user',
	},
];
export const RBDMSiteSummaryTab: ITabList[] = [
	{
		key: 1,
		name: 'All Sites',
		pathUrl: '/rbdm/site-summary',
		tabIcon: 'icon-tool',
	},
];
export const SiteSummaryTabKAESSUser: ITabList[] = [
	{
		key: 1,
		name: 'All Sites',
		pathUrl: '/site-summary',
		tabIcon: 'icon-tool',
	},
	{
		key: 2,
		name: 'Site Not Visited',
		pathUrl: '/site-summary/new-leads',
		tabIcon: 'icon-tool',
	},
];
export const SiteSummaryTabKAEUser: ITabList[] = [
	{
		key: 1,
		name: 'All Sites',
		pathUrl: '/site-summary',
		tabIcon: 'icon-tool',
	},
	{
		key: 2,
		name: 'Site Specialist Sites',
		pathUrl: '/site-summary/site-specialist-sites',
		tabIcon: 'icon-tool',
	},
];

export const SiteSummaryTabContractor: ITabList[] = [
	{
		key: 1,
		name: 'All Sites',
		pathUrl: '/contractor/site-summary',
		tabIcon: 'icon-tool',
	},
	{
		key: 2,
		name: 'SS Sites',
		pathUrl: '/contractor/site-specialist-site-summary',
		tabIcon: 'icon-tool',
	},
];

export interface ISiteSummaryList {
	id: number;
	name: string;
	contract_name: string;
	contract_phone: string;
	status_c: string | null;
	createddate: string | null;
	sitenumber_c: string;
	competition_products_at_site_c: string | null;
	lastactivitydate: string | null;
	assigned_cmdi_c: string | null;
	primary_cmdi?: string | null;
	sfid: string;
	current_stage_of_site_c: string;
	site_lead_status: string | null;
	site_status_c: string | null;
	site_current_status_c?: string | null;
	site_location_c: string;
	site_state_c: string | null;
	sitecode_c: string | null;
	type_of_record_c: string;
	adopted_site: boolean;
	competition_site: boolean;
	membership_no?: string;
	visited_by: string | null;
	supervisor_phone_number: string | null;
	brand_of_glue_used_at_site: string | null;
	glue_potential: string | null;
	site_area: string | null;
	supervisor_name: string | null;
	source_of_site_field_others_c: string | null;
	lead_contractor_name?: string | null;
	lead_contractor_phone?: string | null;
	lead_membership_no?: string | null;
	end_user_source?: string | null;
	cmdi_code_c?: string | null;
	latitude?: string | null;
	longitude?: string | null;
	roff_substrate_c?: string | null;
	epoxy_adhesive_used_c?: string | null;
	fv_glue_used_so_far?: string | null;
	mdicode_c?: string | null;
	source_of_site_lead_c?: string | null;
	fetchcmdi_c?: string | null;
}

export interface ISiteSummaryCardProps {
	site: ISiteSummaryList;
	showKaeFields?: boolean;
	showKaeMicrositeDetails?: boolean;
}

export interface ISiteSummarySearchProps {
	setSortCallback: () => void;
	setFilterCallback: () => void;
}
